module.exports = __webpack_public_path__ + "img/caseVisitors.3038aefe.png";